import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { MenuItem, Stack, TextField, Typography } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { FloatScanButton } from 'components';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSDK } from 'stores';
import { MotionWrapper } from 'utils';
import './index.css';

/*
interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

function TabPanel(props: TabPanelProps) {
	const { t } = useTranslation();
	const { children, value, index, ...other } = props;
	const { sysInfo } = useSDK();
	let [modelSelect, setModelSelect] = useState(0);
	const [expanded, setExpanded] = React.useState<string | false>(false);

	const handleChange =
		(panel: string) =>
		(event: React.SyntheticEvent, isExpanded: boolean) => {
			setExpanded(isExpanded ? panel : false);
		};

	useEffect(() => {
		const OS = sysInfo?.equipmentOS.toLowerCase();
		if (OS === 'ios') {
			setModelSelect(1);
		} else if (OS === 'android') {
			setModelSelect(2);
		}
	}, []);

	const returnTab = () => {
		switch (value) {
			case 0:
				return (
					<>
						<Typography className="FAQ FAQ-Q">
							{t('FAQ.Q1')}
						</Typography>
						<Typography className="FAQ FAQ-A">
							{t('FAQ.A1')}
						</Typography>
						<Typography className="FAQ FAQ-Q">
							{t('FAQ.Q2')}
						</Typography>
						<Typography className="FAQ FAQ-A">
							{t('FAQ.A2')}
						</Typography>
						<Typography className="FAQ FAQ-Q">
							{t('FAQ.Q3')}
						</Typography>
						<Typography className="FAQ FAQ-A">
							{t('FAQ.A3')}
						</Typography>
						<Typography className="FAQ FAQ-Q">
							{t('FAQ.Q4')}
						</Typography>
						<Typography className="FAQ FAQ-A">
							{t('FAQ.A4')}
						</Typography>
					</>
				);
			case 1:
				return (
					<>
						<TextField
							fullWidth
							select
							value={modelSelect}
							onChange={(e) => {
								setModelSelect(parseInt(e.target.value));
							}}
							sx={{
								pl: 2,
								pr: 2,
							}}
						>
							<MenuItem value={1}>{t('issue.iPhone')}</MenuItem>
							<MenuItem value={2}>{t('issue.Android')}</MenuItem>
							<MenuItem value={0}>{t('issue.All')}</MenuItem>
						</TextField>
						<Box
							sx={{ p: 2 }}
							display={modelSelect !== 1 ? 'none' : 'auto'}
						>
							<Accordion
								expanded={expanded === 'iPhone1'}
								onChange={handleChange('iPhone1')}
								sx={{ backgroundColor: 'transparent' }}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
								>
									<Typography
										className="known_issue_item_title"
										variant="body2"
									>
										{t('issue.iPhone1.title')}
									</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<Typography className="known_issue_item_content">
										<Typography
											variant="body2"
											component="span"
											sx={{ fontWeight: 'bold' }}
										>
											{t('issue.content.date')}
										</Typography>
										<Typography
											variant="body2"
											component="span"
										>
											{t('issue.iPhone1.content.date')}
										</Typography>
									</Typography>
									<Typography className="known_issue_item_content">
										<Typography
											variant="body2"
											component="span"
											sx={{ fontWeight: 'bold' }}
										>
											{t('issue.content.affect')}
										</Typography>
										<Typography
											variant="body2"
											component="span"
										>
											{t('issue.iPhone1.content.affect')}
										</Typography>
									</Typography>
									<Typography className="known_issue_item_content">
										<Typography
											variant="body2"
											component="span"
											sx={{ fontWeight: 'bold' }}
										>
											{t('issue.content.symptom')}
										</Typography>
										<Typography
											variant="body2"
											component="span"
										>
											{t('issue.iPhone1.content.symptom')}
										</Typography>
									</Typography>
									<Typography className="known_issue_item_content">
										<Typography
											variant="body2"
											component="span"
											sx={{ fontWeight: 'bold' }}
										>
											{t('issue.content.workaround')}
										</Typography>
										<br />
										<Typography
											variant="body2"
											component="span"
										>
											{t(
												'issue.iPhone1.content.workaround'
											)}
										</Typography>
									</Typography>
									<Typography className="known_issue_item_content">
										<Typography
											variant="body2"
											component="span"
											sx={{ fontWeight: 'bold' }}
										>
											{t('issue.content.fix')}
										</Typography>
										<br />
										<Typography
											variant="body2"
											component="span"
										>
											{t('issue.iPhone1.content.fix')}
										</Typography>
									</Typography>
									<Typography className="known_issue_item_content">
										<Typography
											variant="body2"
											component="span"
											sx={{ fontWeight: 'bold' }}
										>
											{t('issue.content.other')}
										</Typography>
										<br />
										<Typography
											variant="body2"
											component="span"
										>
											{t('issue.iPhone1.content.other')}
										</Typography>
									</Typography>
									<Typography className="known_issue_item_content">
										<Typography
											variant="body2"
											component="span"
											sx={{ fontWeight: 'bold' }}
										>
											{t('issue.content.cause')}
										</Typography>
										<br />
										<Typography
											variant="body2"
											component="span"
										>
											{t('issue.iPhone1.content.cause')}
										</Typography>
									</Typography>
								</AccordionDetails>
							</Accordion>
						</Box>
						<Box sx={{ p: 2 }}>
							<Accordion
								expanded={expanded === 'All1'}
								onChange={handleChange('All1')}
								sx={{ backgroundColor: 'transparent' }}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
								>
									<Typography
										className="known_issue_item_title"
										variant="body2"
									>
										{t('issue.All1.title')}
									</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<Typography className="known_issue_item_content">
										<Typography
											variant="body2"
											component="span"
											sx={{ fontWeight: 'bold' }}
										>
											{t('issue.content.affect')}
										</Typography>
										<Typography
											variant="body2"
											component="span"
										>
											{t('issue.All1.content.affect')}
										</Typography>
									</Typography>
									<Typography className="known_issue_item_content">
										<Typography
											variant="body2"
											component="span"
											sx={{ fontWeight: 'bold' }}
										>
											{t('issue.content.symptom')}
										</Typography>
										<Typography
											variant="body2"
											component="span"
										>
											{t('issue.All1.content.symptom')}
										</Typography>
									</Typography>
									<Typography className="known_issue_item_content">
										<Typography
											variant="body2"
											component="span"
											sx={{ fontWeight: 'bold' }}
										>
											{t('issue.content.workaround')}
										</Typography>
										<Typography
											variant="body2"
											component="span"
										>
											{t('issue.All1.content.workaround')}
										</Typography>
									</Typography>
									<Typography className="known_issue_item_content">
										<Typography
											variant="body2"
											component="span"
											sx={{ fontWeight: 'bold' }}
										>
											{t('issue.content.cause')}
										</Typography>
										<Typography
											variant="body2"
											component="span"
										>
											{t('issue.All1.content.cause')}
										</Typography>
									</Typography>
								</AccordionDetails>
							</Accordion>
							<Accordion
								expanded={expanded === 'All2'}
								onChange={handleChange('All2')}
								sx={{ backgroundColor: 'transparent' }}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
								>
									<Typography
										className="known_issue_item_title"
										variant="body2"
									>
										{t('issue.All2.title')}
									</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<Typography className="known_issue_item_content">
										<Typography
											variant="body2"
											component="span"
										>
											{t('issue.All2.content.other')}
										</Typography>
										<Typography
											variant="body2"
											component="span"
										>
											{t('issue.FAQ')}
										</Typography>
										<Typography
											variant="body2"
											component="span"
										>
											{t('issue.fullStop')}
										</Typography>
									</Typography>
								</AccordionDetails>
							</Accordion>
						</Box>
					</>
				);
			default:
				return null;
		}
	};

	const computeHeight = () => {
		const root = document.getElementById('root');
		const height = root!.clientHeight;
		return 'calc(' + height + 'px - 48px - 56px - 32px)';
	};

	return (
		<Box
			mt={2}
			hidden={value !== index}
			{...other}
			sx={{
				height: computeHeight(),
				overflowX: 'hidden',
				overflowY: 'scroll',
			}}
		>
			{returnTab()}
		</Box>
	);
}*/

const KnownIssues = () => {
	const { t } = useTranslation();
	//const [value, setValue] = useState(0);
	let [modelSelect, setModelSelect] = useState(0);
	const [expanded, setExpanded] = React.useState<string | false>(false);
	const { sysInfo } = useSDK();

	const handleChange =
		(panel: string) =>
		(event: React.SyntheticEvent, isExpanded: boolean) => {
			setExpanded(isExpanded ? panel : false);
		};

	useEffect(() => {
		const OS = sysInfo?.equipmentOS.toLowerCase();
		console.log('OS -> ' + OS);
		if (OS === 'ios') {
			setModelSelect(1);
		} else if (OS === 'android') {
			setModelSelect(2);
		}
	}, []);
	/*
	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};


	return (
		<>
			<Box sx={{ flexGrow: 1 }}>
				<Tabs value={value} onChange={handleChange} centered>
					<Tab
						disableRipple
						label="已知问题"
						value={0}
						sx={{
							marginRight: '25px',
							fontSize: '1em',
						}}
					/>
					<Tab
						disableRipple
						label="常见问题与回答"
						value={1}
						sx={{
							marginLeft: '25px',
							fontSize: '1em',
						}}
					/>
				</Tabs>
				<TabPanel value={value} index={0} />
				<TabPanel value={value} index={1} />
			</Box>
		</>
	);
	*/
	return (
		<MotionWrapper spacing={0}>
			<TextField
				fullWidth
				select
				value={modelSelect}
				onChange={(e) => {
					setModelSelect(parseInt(e.target.value));
				}}
				sx={{
					pl: 2,
					pr: 2,
				}}
			>
				<MenuItem value={1}>{t('issue.iPhone')}</MenuItem>
				<MenuItem value={2}>{t('issue.Android')}</MenuItem>
				<MenuItem value={0}>{t('issue.All')}</MenuItem>
			</TextField>
			<Stack
				spacing={1}
				p={2}
				pt={0.5}
				mt={1.5}
				pb={6}
				direction="column"
				sx={{ overflow: 'scroll' }}
			>
				<Accordion
					expanded={expanded === 'iPhone1'}
					onChange={handleChange('iPhone1')}
					sx={{
						backgroundColor: 'transparent',
						display: () => (modelSelect !== 1 ? 'none' : 'auto'),
					}}
				>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}>
						<Typography
							className="known_issue_item_title"
							variant="body2"
						>
							{t('issue.iPhone1.title')}
						</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<Typography className="known_issue_item_content">
							<Typography
								variant="body2"
								component="span"
								sx={{ fontWeight: 'bold' }}
							>
								{t('issue.content.date')}
							</Typography>
							<Typography variant="body2" component="span">
								{t('issue.iPhone1.content.date')}
							</Typography>
						</Typography>
						<Typography className="known_issue_item_content">
							<Typography
								variant="body2"
								component="span"
								sx={{ fontWeight: 'bold' }}
							>
								{t('issue.content.affect')}
							</Typography>
							<Typography variant="body2" component="span">
								{t('issue.iPhone1.content.affect')}
							</Typography>
						</Typography>
						<Typography className="known_issue_item_content">
							<Typography
								variant="body2"
								component="span"
								sx={{ fontWeight: 'bold' }}
							>
								{t('issue.content.symptom')}
							</Typography>
							<Typography variant="body2" component="span">
								{t('issue.iPhone1.content.symptom')}
							</Typography>
						</Typography>
						<Typography className="known_issue_item_content">
							<Typography
								variant="body2"
								component="span"
								sx={{ fontWeight: 'bold' }}
							>
								{t('issue.content.workaround')}
							</Typography>
							<br />
							<Typography variant="body2" component="span">
								{t('issue.iPhone1.content.workaround')}
							</Typography>
						</Typography>
						<Typography className="known_issue_item_content">
							<Typography
								variant="body2"
								component="span"
								sx={{ fontWeight: 'bold' }}
							>
								{t('issue.content.fix')}
							</Typography>
							<br />
							<Typography variant="body2" component="span">
								{t('issue.iPhone1.content.fix')}
							</Typography>
						</Typography>
						<Typography className="known_issue_item_content">
							<Typography
								variant="body2"
								component="span"
								sx={{ fontWeight: 'bold' }}
							>
								{t('issue.content.other')}
							</Typography>
							<br />
							<Typography variant="body2" component="span">
								{t('issue.iPhone1.content.other')}
							</Typography>
						</Typography>
						<Typography className="known_issue_item_content">
							<Typography
								variant="body2"
								component="span"
								sx={{ fontWeight: 'bold' }}
							>
								{t('issue.content.cause')}
							</Typography>
							<br />
							<Typography variant="body2" component="span">
								{t('issue.iPhone1.content.cause')}
							</Typography>
						</Typography>
					</AccordionDetails>
				</Accordion>
				<Accordion
					expanded={expanded === 'All1'}
					onChange={handleChange('All1')}
					sx={{ backgroundColor: 'transparent' }}
				>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}>
						<Typography
							className="known_issue_item_title"
							variant="body2"
						>
							{t('issue.All1.title')}
						</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<Typography className="known_issue_item_content">
							<Typography
								variant="body2"
								component="span"
								sx={{ fontWeight: 'bold' }}
							>
								{t('issue.content.affect')}
							</Typography>
							<Typography variant="body2" component="span">
								{t('issue.All1.content.affect')}
							</Typography>
						</Typography>
						<Typography className="known_issue_item_content">
							<Typography
								variant="body2"
								component="span"
								sx={{ fontWeight: 'bold' }}
							>
								{t('issue.content.symptom')}
							</Typography>
							<Typography variant="body2" component="span">
								{t('issue.All1.content.symptom')}
							</Typography>
						</Typography>
						<Typography className="known_issue_item_content">
							<Typography
								variant="body2"
								component="span"
								sx={{ fontWeight: 'bold' }}
							>
								{t('issue.content.workaround')}
							</Typography>
							<Typography variant="body2" component="span">
								{t('issue.All1.content.workaround')}
							</Typography>
						</Typography>
						<Typography className="known_issue_item_content">
							<Typography
								variant="body2"
								component="span"
								sx={{ fontWeight: 'bold' }}
							>
								{t('issue.content.cause')}
							</Typography>
							<Typography variant="body2" component="span">
								{t('issue.All1.content.cause')}
							</Typography>
						</Typography>
					</AccordionDetails>
				</Accordion>
				<Accordion
					expanded={expanded === 'All2'}
					onChange={handleChange('All2')}
					sx={{ backgroundColor: 'transparent' }}
				>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}>
						<Typography
							className="known_issue_item_title"
							variant="body2"
						>
							{t('issue.All2.title')}
						</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<Typography className="known_issue_item_content">
							<Typography variant="body2" component="span">
								{t('issue.All2.content.other')}
							</Typography>
							<Typography variant="body2" component="span">
								{t('issue.FAQ')}
							</Typography>
							<Typography variant="body2" component="span">
								{t('issue.fullStop')}
							</Typography>
						</Typography>
					</AccordionDetails>
				</Accordion>
			</Stack>
			<FloatScanButton />
		</MotionWrapper>
	);
};

export default KnownIssues;
